import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../firebase.ts";
import { useState } from "react";


export interface CompanyInfo {
  corporateNumber: string;
  clientCompanyName: string;
  postalCode: string;
  prefecture: string;
  city: string;
  address1: string;
}

interface RequestByName {
  companyName: string;
}

interface RequestByNumber {
  corporateNumber: string;
}

// Interface for parsed CSV data to maintain compatibility with existing UI
export interface ResponseByName {
  companyInfoList: CompanyInfo[];
}

export const useCompanyInfoByName = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const [companyInfoList, setCompanyInfoList] = useState<CompanyInfo[]>([]);

  const getCompanyInfo = async (companyName: string): Promise<CompanyInfo[]> => {
    setIsLoading(true);
    setError("");

    try {
      const functions = getFirebaseFunctions();
      const getCompanyInfoFunction = httpsCallable<RequestByName, ResponseByName>(
        functions,
        "getCompanyInfoByName",
      );
      const res = await getCompanyInfoFunction({
        companyName,
      });

      const data = res.data.companyInfoList;
      setCompanyInfoList(data);
      return data;
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err));
      setError(error.message);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { getCompanyInfo, isLoading, error, companyInfoList };
};


export const useCompanyInfoByNumber = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const [companyInfoList, setCompanyInfoList] = useState<CompanyInfo[]>([]);

  const getCompanyInfoByNumber = async (corporateNumber: string): Promise<CompanyInfo[]> => {
    setIsLoading(true);
    setError("");

    try {
      const functions = getFirebaseFunctions();
      const getCompanyInfoFunction = httpsCallable<RequestByNumber, ResponseByName>(
        functions,
        "getCompanyInfoByNumber",
      );
      const res = await getCompanyInfoFunction({
        corporateNumber,
      });

      const data = res.data.companyInfoList;
      setCompanyInfoList(data);
      return data;
    } catch (err) {
      const error = err instanceof Error ? err : new Error(String(err));
      setError(error.message);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { getCompanyInfoByNumber, isLoading, error, companyInfoList };
};
